import script from "./WordPressDeploymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WordPressDeploymentPage.vue?vue&type=script&setup=true&lang=js"

import "./WordPressDeploymentPage.vue?vue&type=style&index=0&id=76e9217f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e9217f"]])

export default __exports__